import { render, staticRenderFns } from "./HospitalBillingDataTable.vue?vue&type=template&id=0c6f3368&scoped=true"
import script from "./HospitalBillingDataTable.vue?vue&type=script&lang=js"
export * from "./HospitalBillingDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f3368",
  null
  
)

export default component.exports